// extracted by mini-css-extract-plugin
module.exports = {"form":"NotePopover_form__LeGeH"};